import React, { useContext } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import cn from 'classnames';
import styles from './Header.module.sass';
import Image from '../Image';
import User from './User';
import Control from '../Control';
import Notification from './Notification';
import SearchInput from '../SearchInput';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import { SearchContext } from '../../contexts/SearchContext';

const breadcrumbs = [
    {
        title: 'Profile',
        url: '/profile',
    },
    {
        title: 'Edit Profile',
    },
];


const Headers = ({location}) => {


    const isChat = location.pathname.includes('chat');

    const chatIcon = isChat ? '/assets/icon_chat.png' : '/assets/icon_chat_blue.png';


    const {search,setSearch} = useContext( SearchContext );

    return (
        <header>
            <div className={styles.fixedContainer}>
                <div className={cn( styles.header_zone, styles.left)}>
                    <Link className={styles.logo} to='/'>
                        <Image
                            className={styles.pic}
                            src='/assets/Logo.svg'
                            srcDark='/assets/Logo.svg'
                            alt='Nowwa'
                        />
                    </Link>
                </div>
                {/*
                <div className={cn( styles.header_zone, styles.center)}>
                     <SearchInput className={styles.searchInput} onChange={(value) => {setSearch (value)}} value={search}/> 
                </div>
                */}
                <div className={cn( styles.header_zone, styles.right)}>
                    <div className={styles.iconsContainer}>
                        {/* <Link to={'/chat'}><Image src={chatIcon} srcDark={chatIcon}/> </Link> */}
                        <Notification className={styles.notification} />
                    </div>
                    <User className={styles.user} />
                </div>
                {/* <SearchInput className={styles.searchInputMobile} onChange={(value) => {setSearch(value)}} value={search}/> */}
            </div>
        </header>
    );
    
};

export default withRouter(Headers);
